import { fromJS } from 'immutable';

export const initialState = fromJS({
    isLoading: true,
    me: undefined,
    selectedMemberGroup: {}
});